import React from 'react';

/* Reusable component for primary button */
const PrimaryButton = ({ children, className = '', ...props }) => (
  <button
    type="button"
    className={`primary-gradient-btn fw-bold border-0 rounded ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default PrimaryButton; 